import Tooltip from './Tooltip'

export default function FormFieldCheckbox (props) {
  return (
    <label className="wp-block-gds-lead-form__form-field wp-block-gds-lead-form__form-field--checkbox">
      <input
        type="checkbox"
        required={props.required}
        checked={props.value}
        onChange={() => props.onChange?.(!props.value)}
      />
      {props.label}{props.required ? '*' : ''}
      {props.tooltip && <Tooltip>{props.tooltip}</Tooltip>}
    </label>
  )
}
